<template>
  <main>
    <InputFilter class="pt-10" :pagination="pagination" />
    <section class="filter-area">
      <v-container class="py-0">
        <v-row>
          <v-col cols="12" sm="10" class="mx-auto py-0">
            <v-row justify="space-between">
              <v-col cols="12" sm="6" class="camp-type py-0">
                <v-autocomplete
                  :items="camps"
                  item-text="name"
                  item-value="id"
                  label="Camp Name"
                  filled
                  dense
                  :append-icon="filter.camp_id ? 'mdi-close' : ''"
                  @click:append="clearSearchData('camp_id')"
                  v-model="filter.camp_id"
                  @change="filterCamp"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="6" class="location py-0">
                <v-autocomplete
                  :items="discounts"
                  item-text="name"
                  item-value="id"
                  label="Discount Name"
                  filled
                  dense
                  :append-icon="filter.discount_id ? 'mdi-close' : ''"
                  @click:append="clearSearchData('discount_id')"
                  v-model="filter.discount_id"
                  @change="filterDiscount"
                ></v-autocomplete>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </section>
    <v-container>
      <v-toolbar flat class="main-header mb-12">
        <v-toolbar-title class="main-header__title">
          <h1>Promocodes</h1>
        </v-toolbar-title>

        <v-spacer></v-spacer>
        <!-- v-if="permissions.includes('store_api_admin-panel_promocodes')" -->
        <v-toolbar-items
          v-if="permissions.includes('store_api_admin-panel_promo-codes')"
          class="main-header__contents"
        >
          <v-btn
            class="radius-12 my-auto mx-1"
            color="success"
            to="/list/promocodes/create"
          >
            <v-icon>mdi-plus-circle</v-icon>
            <span class="mx-2">New Code</span>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-data-table
        :headers="headers"
        :items="promocodes"
        :loading="loadingpromocodes"
        :mobile-breakpoint="zero"
        :items-per-page="20"
        class="table"
        hide-default-footer
      >
        <template v-slot:item="{ item }">
          <tr class="table__row">
            <td class="table__cell text-center name">
              {{ item.group_owner_email || "---" }}
            </td>
            <td class="table__cell text-center">{{ item.code || "---" }}</td>
            <td class="table__cell text-center">
              <span v-if="item.expiry_date">{{
                item.expiry_date | moment("Do,MMM' YYYY")
              }}</span>
              <span v-else>---</span>
            </td>
            <td class="table__cell text-center">
              {{ item.capacity_range || "---" }}
            </td>
            <td class="table__cell text-center">
              {{ item.discount_id ? item.discount_id.name : "---" }}
            </td>
            <td class="table__cell text-center">
              <v-chip
                v-if="!item.is_active"
                small
                color="#faddd2"
                text-color="#ec531e"
              >
                <v-avatar left>
                  <v-icon small>mdi-close-circle</v-icon>
                </v-avatar>
                Inactive
              </v-chip>
              <v-chip v-else small color="#dcf3d1" text-color="#82c565">
                <v-avatar left>
                  <v-icon small>mdi-checkbox-marked-circle</v-icon>
                </v-avatar>
                Active
              </v-chip>
            </td>
            <td class="table__cell text-center">
              <v-icon
                v-if="item.members.length > 0"
                @click="membersShow(item)"
                small
                >mdi-eye</v-icon
              >
              <span v-else>Not used yet</span>
            </td>

            <td class="table__cell text-center">
              <router-link
                class="hovering mr-1 edit"
                :to="{ name: 'promocodesEdit', params: { id: item.id } }"
                v-if="
                  permissions.includes(
                    'update_api_admin-panel_promo-codes_{promo_code}'
                  )
                "
              >
                <v-icon small>mdi-pencil</v-icon><br />
                Edit
              </router-link>
              <span v-else>---</span>
            </td>
          </tr>
        </template>
      </v-data-table>
      <v-dialog v-model="dialog" max-width="750">
        <v-card>
          <v-card-title class="font-bold py-5" primary-title>
            <h3>
              <span>Members</span>
            </h3>
            <br />
            <v-spacer></v-spacer>
            <v-icon @click="dialog = false">mdi-close</v-icon>
          </v-card-title>
          <p class="px-6">Who used the promocode</p>

          <v-card-text class="pa-0">
            <v-simple-table class="teams members">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-center">Account No</th>
                    <th class="text-center">Email</th>
                    <th class="text-center">Order ID</th>
                    <th class="text-center">Date Reg</th>
                    <th class="text-center">Status</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in members" :key="item.name">
                    <td class="text-center">{{ item.account }}</td>
                    <td class="text-center">{{ item.email }}</td>
                    <td class="text-center">{{ item.wellspring_order_id }}</td>
                    <td class="text-center">
                      <span v-if="item.reg_date">{{
                        item.reg_date | moment("Do,MMM' YYYY")
                      }}</span>
                      <span v-else>---</span>
                    </td>
                    <td class="text-center">{{ item.status }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>
        </v-card>
      </v-dialog>
      <!-- pagination -->
      <div class="text-xs-center pt-2">
        <v-pagination
          v-if="promocodes.length > 0 && pagination.last_page > 1"
          v-model="pagination.current_page"
          :length="pagination.last_page"
          :total-visible="20"
          @input="handlePagination"
        ></v-pagination>
      </div>
      <!-- pagination -->
    </v-container>
  </main>
</template>

<script>
import { IndexData } from "@/helpers/apiMethods";
import TableHeaders from "@/helpers/TableHeaders";
import { isEqual } from "lodash";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      zero: 0,
      headers: [],
      promocodes: [],
      pagination: {},
      queries: {},
      loadingpromocodes: false,
      filter: {
        type: "",
        camp_id: "",
        discount_id: ""
      },
      camp_locations: [],
      camps: [],
      discounts: [],
      drawer: null,
      dialog: false,
      members: {}
    };
  },
  components: {
    InputFilter: () => import("@/views/accounts/components/InputFilter")
  },
  computed: {
    ...mapGetters({
      permissions: "permissions"
    })
  },
  created() {
    // this.indexpromocodes();
    this.promocodesHeaders();
    this.indexLists();
  },
  methods: {
    indexpromocodes(query) {
      this.loadingpromocodes = true;
      IndexData({ reqName: "promo-codes", query })
        .then(res => {
          const { data, meta } = res.data;
          this.promocodes = data;
          this.loadingpromocodes = false;
          this.pagination = meta;
        })
        .catch(() => {})
        .finally(() => {});
    },
    indexLists() {
      IndexData({ reqName: `/promo-code/lists` })
        .then(res => {
          this.camps = res.data.camps;
          this.discounts = res.data.discounts;
        })
        .catch(() => {})
        .finally(() => {});
    },
    promocodesHeaders() {
      const headersList = [
        "Group Owner",
        "Promo Code",
        "Expiry Date",
        "Capacity",
        "Discount",
        "Activity",
        "Members",
        "Actions"
      ];
      this.headers = TableHeaders(headersList);
    },
    createCamp() {
      this.$route.push("/promocodes/create");
    },
    handlePagination(page) {
      this.queries = { ...this.queries, page };
      if (!isEqual(this.queries, this.$route.query)) {
        this.$router.push({ query: this.queries });
      }
    },
    filterCamp(camp_id) {
      let routeQuery = { ...this.$route.query };
      this.$router.push({ query: { ...routeQuery, camp_id, page: 1 } });
    },
    filterDiscount(discount_id) {
      let routeQuery = { ...this.$route.query };
      this.$router.push({ query: { ...routeQuery, discount_id, page: 1 } });
    },
    clearSearchData(name) {
      let routeQuery = { ...this.$route.query };
      this.filter[name] = "";
      delete routeQuery[name];
      this.$router.push({ query: routeQuery });
    },
    membersShow(item) {
      console.log(item);
      this.dialog = true;
      this.members = item.members;
    }
  },
  watch: {
    $route: {
      handler(route) {
        const { query } = route;
        this.queries = query;
        this.pagination.current_page = query.page;
        if (query.camp_id) {
          this.filter.camp_id = Number(query.camp_id);
        }
        if (query.discount_id) {
          this.filter.discount_id = Number(query.discount_id);
        }
        let decodedQuery = {};
        for (const key in query) {
          decodedQuery[key] = encodeURIComponent(query[key]);
        }
        this.indexpromocodes(decodedQuery);
      },
      immediate: true
    }
  }
};
</script>
